import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=4e972d80&scoped=true&"
import script from "./IntegrationView.vue?vue&type=script&lang=ts&"
export * from "./IntegrationView.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationView.vue?vue&type=style&index=0&id=4e972d80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e972d80",
  null
  
)

export default component.exports